import axios from "axios";

const POSTEMAIL_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/auth/confirm";
const POSTCONFIRMATION_API_BASE_URL =
  "https://doclicapp.herokuapp.com/api/auth/confirm2";
class ServiceForget {
  postemail(email) {
    return axios.post(POSTEMAIL_API_BASE_URL, { email: email });
  }
  postconfirmation(email, password, confirmPassword) {
    return axios.post(POSTCONFIRMATION_API_BASE_URL, {
      email: email,
      password: password,
      confirmPassword: confirmPassword,
    });
  }
}

export default new ServiceForget();
